import { render, staticRenderFns } from "./PluginUblSettingsGeneral.vue?vue&type=template&id=042e366e"
import script from "./PluginUblSettingsGeneral.vue?vue&type=script&lang=ts"
export * from "./PluginUblSettingsGeneral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('042e366e')) {
      api.createRecord('042e366e', component.options)
    } else {
      api.reload('042e366e', component.options)
    }
    module.hot.accept("./PluginUblSettingsGeneral.vue?vue&type=template&id=042e366e", function () {
      api.rerender('042e366e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/PluginUblSettingsGeneral.vue"
export default component.exports